import type {ReactElement} from 'react';
import type {ContainerQueryObject} from '@Hooks/useContainerQuery';

export enum InspirationLayoutVariant {
  BottomRightRadius = 'BottomRightRadius',
  BottomLeftRadius = 'BottomLeftRadius',
  TopRightRadius = 'TopRightRadius',
  TopLeftRadius = 'TopLeftRadius',
  Centered = 'Centered',
  FullWidth = 'FullWidth',
}

export enum InspirationWidthVariant {
  ExtraNarrow = 'ExtraNarrow',
  Narrow = 'Narrow',
  MediumNarrow = 'MediumNarrow',
  Medium = 'Medium',
  MediumWide = 'MediumWide',
  Wide = 'Wide',
}

export enum InspirationsWidth {
  Regular = 'Regular',
  Narrow = 'Narrow',
  ExtraNarrow = 'ExtraNarrow',
}

export const INSPIRATIONS_WIDTH_QUERY: ContainerQueryObject = {
  [InspirationsWidth.Narrow]: {maxWidth: 650},
  [InspirationsWidth.ExtraNarrow]: {maxWidth: 500},
};

export interface InspirationData {
  visualLayoutVariant: InspirationLayoutVariant;
  imageURL: string;
  imageURLToConvertTo?: string;
  attachmentURL?: string;
  pillText: string;
  pillIcon: string;
  prompt: string;
  widthVariant: InspirationWidthVariant;
  onRecreate: () => void;
  imageClasses?: string;
}

export interface AiChatWindowInspirationsProps {
  inspirations: InspirationData[];
  cardsDecoration?: ReactElement;
}

